import { createRouter, createWebHistory } from 'vue-router'
import { usePaymentStore } from '@/entities/Payment/model/paymentStore'
import { SentryService } from '@/shared/lib/sentry/sentryService'
import { isTelegramSession } from '@/shared/lib/telegram/runtime'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/HomePage/HomePage.vue'),
    },
    {
      path: '/payment',
      name: 'payment',
      component: () => import('@/pages/PaymentPage.vue/PaymentPage.vue'),
    },
    {
      path: '/my-subscription',
      name: 'my-subscription',
      component: () => import('@/pages/MySubscription/MySubscription.vue')
    },
    {
      path: '/my-subscription/:id',
      name: 'my-subscription-detail',
      component: () => import('@/pages/MySubscription/MySubscription.vue')
    },
    {
      path: '/my-subscriptions',
      name: 'my-subscriptions',
      component: () => import('@/pages/MySubscriptions/MySubscriptions.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('@/pages/PaymentPage.vue/SuccessPage.vue')
    },
    {
      path: '/error',
      name: 'error',
      component: () => import('@/pages/PaymentPage.vue/ErrorPage.vue')
    },
    {
      path: '/setup',
      name: 'setup',
      component: () => import('@/pages/SetupPage/SetupPage.vue')
    },
    {
      path: '/setup/:id',
      name: 'setup-detail',
      component: () => import('@/pages/SetupPage/SetupPage.vue')
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('@/pages/PolicyPage/PolicyPage.vue')
    },
  ],
})

// Глобальный guard для обновления данных при переходе на главную страницу
router.beforeEach((to, from, next) => {
  // Отправляем отчет о навигации в Sentry
  SentryService.trackNavigation(String(from.name || 'unknown'), String(to.name || 'unknown'), {
    from_path: from.path,
    to_path: to.path,
    from_params: from.params,
    to_params: to.params
  })
  
  // Проверяем, произошло ли обновление страницы
  // При обновлении from.name === undefined и to.name !== 'home'
  const isPageRefresh = !from.name && to.name !== 'home' && to.name !== 'policy'
  const shouldForceHomeOnRefresh = isPageRefresh && isTelegramSession()
  
  if (shouldForceHomeOnRefresh) {
    console.log('🔄 Обнаружено обновление страницы, перенаправляем на главную')
    // Очищаем все временные флаги
    sessionStorage.removeItem('cameFromHome')
    sessionStorage.removeItem('purchaseType')
    sessionStorage.removeItem('isExtensionFlow')
    sessionStorage.removeItem('paymentSuccess')
    sessionStorage.removeItem('paymentError')
    sessionStorage.removeItem('refreshDataOnHome')
    
    // Перенаправляем на главную страницу
    next({ name: 'home', replace: true })
    return
  }
  
  // Останавливаем проверку статуса оплаты при любом переходе со страницы оплаты
  if (from.name === 'payment') {
    try {
      const paymentStore = usePaymentStore()
      console.log('Переход со страницы оплаты, останавливаем проверку статуса')
      paymentStore.stopPaymentStatusPolling()
    } catch (error) {
      console.warn('Ошибка при остановке проверки статуса оплаты:', error)
    }
  }
  
  // Если переходим на главную страницу с любой страницы, связанной с оплатой или страницы setup
  if (to.name === 'home' && (from.name === 'success' || from.name === 'error' || from.name === 'payment' || from.name === 'setup' || from.name === 'setup-detail')) {
    // Устанавливаем флаг для обновления данных
    sessionStorage.setItem('refreshDataOnHome', 'true')
  }
  
  next()
})

// Обработка ошибок роутера
router.onError((error) => {
  console.error('Router error:', error)
  SentryService.trackError(error, {
    error_type: 'router_error'
  }, 'Ошибка роутера')
})

export default router
